import { QueryKey, useQuery } from "react-query";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";
import { getPermitsCustomFields } from "../../../../queries/permitsCustomFields";

export default function usePermitCustomFieldsList() {
  const headers = useNetworkHeaders();

  const queryKey = getPermitCustomFieldsListQueryKey();
  const query = useQuery(queryKey, getPermitsCustomFields(headers));

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
  };
}

function getPermitCustomFieldsListQueryKey(): QueryKey {
  return "permitsCustomFields";
}
